export default __webpack_public_path__ + "static/media/Gallery2.aab5d4e6.webp";